import { render } from "./SyncPrompt.vue?vue&type=template&id=25d62c18&scoped=true&ts=true"
import script from "./SyncPrompt.vue?vue&type=script&lang=ts"
export * from "./SyncPrompt.vue?vue&type=script&lang=ts"

import "./SyncPrompt.vue?vue&type=style&index=0&id=25d62c18&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d62c18"]])

export default __exports__